// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: GUuajngUag
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavBar2 from "../../NavBar2"; // plasmic-import: lLCcoonTe6o/component
import RadialSummary from "../../RadialSummary"; // plasmic-import: oyxikxJz0w/component
import ReturnToSection from "../../ReturnToSection"; // plasmic-import: sLoNWUGnIC/component
import ReturnCityOverviewButton from "../../ReturnCityOverviewButton"; // plasmic-import: uOdAuk8zpe/component
import ReturnToListOfCitiesButton from "../../ReturnToListOfCitiesButton"; // plasmic-import: Gm0oD2L2zL/component
import AggBrandInsight from "../../AggBrandInsight"; // plasmic-import: tsPH8cIy7v/component
import ViewFullListButton from "../../ViewFullListButton"; // plasmic-import: AjqMcZdsZW/component
import MapImage from "../../MapImage"; // plasmic-import: 43COgONOe_/component
import TweetIndividual from "../../TweetIndividual"; // plasmic-import: 7yzX8XASK2/component
import CallToActionBanner from "../../CallToActionBanner"; // plasmic-import: yhV9Z2-FHhl/component
import Footer from "../../Footer"; // plasmic-import: EvRh7yjThy6/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicCityPage.module.css"; // plasmic-import: GUuajngUag/css
import Bar2SvgrepoComSvgIcon from "./icons/PlasmicIcon__Bar2SvgrepoComSvg"; // plasmic-import: tqpj03tDlMUQ/icon

createPlasmicElementProxy;

export const PlasmicCityPage__VariantProps = new Array();

export const PlasmicCityPage__ArgProps = new Array("tweetLink");

const $$ = {};

function PlasmicCityPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <Stack__
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <NavBar2
            data-plasmic-name={"navBar2"}
            data-plasmic-override={overrides.navBar2}
            className={classNames("__wab_instance", sty.navBar2)}
          />

          <div
            data-plasmic-name={"titlesSection"}
            data-plasmic-override={overrides.titlesSection}
            className={classNames(projectcss.all, sty.titlesSection)}
          >
            <div className={classNames(projectcss.all, sty.columns__wNsvH)}>
              <div className={classNames(projectcss.all, sty.column___6OUzt)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___0CAgP)}
                >
                  <h1
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.h1__bGsY7
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FFFFFF" }}
                      >
                        {"Consumer Experience Index"}
                      </span>
                    </React.Fragment>
                  </h1>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__pyqfz
                    )}
                  >
                    {
                      "An index benchmarking consumer experience of some of the largest brands across the world."
                    }
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"radialSummaryCol"}
                data-plasmic-override={overrides.radialSummaryCol}
                className={classNames(projectcss.all, sty.radialSummaryCol)}
              >
                <RadialSummary
                  data-plasmic-name={"radialSummary"}
                  data-plasmic-override={overrides.radialSummary}
                  className={classNames("__wab_instance", sty.radialSummary)}
                  leftAligned={true}
                  nobox={true}
                  notWrapped={true}
                  showButton={true}
                />
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"firstSection"}
            data-plasmic-override={overrides.firstSection}
            className={classNames(projectcss.all, sty.firstSection)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__h3Z57)}
            >
              <div className={classNames(projectcss.all, sty.column__cR4Rj)}>
                <div
                  data-plasmic-name={"returnOptions"}
                  data-plasmic-override={overrides.returnOptions}
                  className={classNames(projectcss.all, sty.returnOptions)}
                >
                  <ReturnToSection
                    data-plasmic-name={"returnToSection"}
                    data-plasmic-override={overrides.returnToSection}
                    cityAggReturnLink={`/global-rankings`}
                    className={classNames(
                      "__wab_instance",
                      sty.returnToSection
                    )}
                  />

                  <ReturnCityOverviewButton
                    data-plasmic-name={"returnCityOverviewButton"}
                    data-plasmic-override={overrides.returnCityOverviewButton}
                    className={classNames(
                      "__wab_instance",
                      sty.returnCityOverviewButton
                    )}
                  />

                  <ReturnToListOfCitiesButton
                    data-plasmic-name={"returnToListOfCitiesButton"}
                    data-plasmic-override={overrides.returnToListOfCitiesButton}
                    className={classNames(
                      "__wab_instance",
                      sty.returnToListOfCitiesButton
                    )}
                  />
                </div>
                <div
                  data-plasmic-name={"aggRankingsBox"}
                  data-plasmic-override={overrides.aggRankingsBox}
                  className={classNames(projectcss.all, sty.aggRankingsBox)}
                >
                  <div
                    data-plasmic-name={"aggRankingTitle"}
                    data-plasmic-override={overrides.aggRankingTitle}
                    className={classNames(projectcss.all, sty.aggRankingTitle)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox___1Erx)}
                    >
                      <h1
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.__wab_text,
                          sty.h1__aCBa2
                        )}
                      >
                        {"Rankings of In-Store\nConsumer Experience"}
                      </h1>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___63Q6A
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#01BD00" }}
                          >
                            {"Click a brand"}
                          </span>
                          <React.Fragment>
                            {" to view its consumer experience scores."}
                          </React.Fragment>
                        </React.Fragment>
                      </div>
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___6JrVd
                      )}
                    >
                      <Bar2SvgrepoComSvgIcon
                        data-plasmic-name={"svg"}
                        data-plasmic-override={overrides.svg}
                        className={classNames(projectcss.all, sty.svg)}
                        role={"img"}
                      />
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"horizontalCol"}
                    data-plasmic-override={overrides.horizontalCol}
                    className={classNames(projectcss.all, sty.horizontalCol)}
                  >
                    <Stack__
                      as={"div"}
                      data-plasmic-name={"aggRankingList"}
                      data-plasmic-override={overrides.aggRankingList}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.aggRankingList)}
                    >
                      <div
                        data-plasmic-name={"oneBrandCol"}
                        data-plasmic-override={overrides.oneBrandCol}
                        className={classNames(projectcss.all, sty.oneBrandCol)}
                      >
                        <AggBrandInsight
                          className={classNames(
                            "__wab_instance",
                            sty.aggBrandInsight___3J7Xr
                          )}
                        />

                        <AggBrandInsight
                          className={classNames(
                            "__wab_instance",
                            sty.aggBrandInsight__qc5Ct
                          )}
                        />

                        <AggBrandInsight
                          brandAggScore={
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__hrBxA
                              )}
                            >
                              {"88"}
                            </div>
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.aggBrandInsight__puL
                          )}
                        />

                        <AggBrandInsight
                          className={classNames(
                            "__wab_instance",
                            sty.aggBrandInsight__shO8K
                          )}
                        />

                        <AggBrandInsight
                          className={classNames(
                            "__wab_instance",
                            sty.aggBrandInsight__kKdE
                          )}
                        />

                        <AggBrandInsight
                          className={classNames(
                            "__wab_instance",
                            sty.aggBrandInsight__gbymE
                          )}
                        />
                      </div>
                    </Stack__>
                  </div>
                  <div
                    data-plasmic-name={"fullListCol"}
                    data-plasmic-override={overrides.fullListCol}
                    className={classNames(projectcss.all, sty.fullListCol)}
                  >
                    <ViewFullListButton
                      data-plasmic-name={"viewFullListButton"}
                      data-plasmic-override={overrides.viewFullListButton}
                      className={classNames(
                        "__wab_instance",
                        sty.viewFullListButton
                      )}
                    />
                  </div>
                </div>
              </div>
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.column__wtA4S)}
              >
                <div
                  data-plasmic-name={"cityMapStack"}
                  data-plasmic-override={overrides.cityMapStack}
                  className={classNames(projectcss.all, sty.cityMapStack)}
                >
                  <MapImage
                    data-plasmic-name={"mapImageCity"}
                    data-plasmic-override={overrides.mapImageCity}
                    className={classNames("__wab_instance", sty.mapImageCity)}
                  />
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___9YHpG)}
                >
                  <div
                    data-plasmic-name={"newsTitle"}
                    data-plasmic-override={overrides.newsTitle}
                    className={classNames(projectcss.all, sty.newsTitle)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__dnwDz)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__fMwlx
                        )}
                      >
                        <h1
                          className={classNames(
                            projectcss.all,
                            projectcss.h1,
                            projectcss.__wab_text,
                            sty.h1__pyh1D
                          )}
                        >
                          {"Consumer Experience in the News"}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"twitterNewsTop"}
                    data-plasmic-override={overrides.twitterNewsTop}
                    className={classNames(projectcss.all, sty.twitterNewsTop)}
                  >
                    <div
                      data-plasmic-name={"twitterList"}
                      data-plasmic-override={overrides.twitterList}
                      className={classNames(projectcss.all, sty.twitterList)}
                    >
                      <Stack__
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.columns__bi1Bc
                        )}
                      >
                        <div
                          data-plasmic-name={"newsItemCol"}
                          data-plasmic-override={overrides.newsItemCol}
                          className={classNames(
                            projectcss.all,
                            sty.newsItemCol
                          )}
                        >
                          <TweetIndividual
                            className={classNames(
                              "__wab_instance",
                              sty.tweetIndividual__hTthX
                            )}
                            tweetLink={args.tweetLink}
                          />

                          <TweetIndividual
                            className={classNames(
                              "__wab_instance",
                              sty.tweetIndividual__y4Gna
                            )}
                            tweetLink={args.tweetLink}
                          />
                        </div>
                      </Stack__>
                    </div>
                  </div>
                </div>
              </Stack__>
            </Stack__>
          </div>
          <CallToActionBanner
            data-plasmic-name={"callToActionBanner"}
            data-plasmic-override={overrides.callToActionBanner}
            className={classNames("__wab_instance", sty.callToActionBanner)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__nls2C)}>
            <div
              data-plasmic-name={"twitterNewsTop2"}
              data-plasmic-override={overrides.twitterNewsTop2}
              className={classNames(projectcss.all, sty.twitterNewsTop2)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__zss3D)}>
                <div
                  data-plasmic-name={"newsTitle2"}
                  data-plasmic-override={overrides.newsTitle2}
                  className={classNames(projectcss.all, sty.newsTitle2)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__r63B)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__aMbZi)}
                    >
                      <h1
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.__wab_text,
                          sty.h1__xaqrC
                        )}
                      >
                        {"Consumer Experience in the News"}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"twitterList4"}
                data-plasmic-override={overrides.twitterList4}
                className={classNames(projectcss.all, sty.twitterList4)}
              >
                <Stack__
                  as={"div"}
                  data-plasmic-name={"twitterList2"}
                  data-plasmic-override={overrides.twitterList2}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.twitterList2)}
                >
                  <div
                    data-plasmic-name={"column"}
                    data-plasmic-override={overrides.column}
                    className={classNames(projectcss.all, sty.column)}
                  >
                    <TweetIndividual
                      className={classNames(
                        "__wab_instance",
                        sty.tweetIndividual___0Bqh0
                      )}
                      fullWidthAcross={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? undefined
                          : true
                      }
                      tweetLink={args.tweetLink}
                    />

                    <TweetIndividual
                      className={classNames(
                        "__wab_instance",
                        sty.tweetIndividual__k0ZCq
                      )}
                      fullWidthAcross={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? undefined
                          : true
                      }
                      tweetLink={args.tweetLink}
                    />

                    <TweetIndividual
                      className={classNames(
                        "__wab_instance",
                        sty.tweetIndividual__gj2G0
                      )}
                      fullWidthAcross={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? undefined
                          : true
                      }
                      tweetLink={args.tweetLink}
                    />

                    <TweetIndividual
                      className={classNames(
                        "__wab_instance",
                        sty.tweetIndividual___3KS
                      )}
                      fullWidthAcross={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? undefined
                          : true
                      }
                      tweetLink={args.tweetLink}
                    />

                    <TweetIndividual
                      className={classNames(
                        "__wab_instance",
                        sty.tweetIndividual__shq4J
                      )}
                      fullWidthAcross={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? undefined
                          : true
                      }
                      tweetLink={args.tweetLink}
                    />

                    <TweetIndividual
                      className={classNames(
                        "__wab_instance",
                        sty.tweetIndividual___2Jt5O
                      )}
                      fullWidthAcross={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? undefined
                          : true
                      }
                      tweetLink={args.tweetLink}
                    />
                  </div>
                </Stack__>
              </div>
            </div>
          </div>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </Stack__>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar2",
    "titlesSection",
    "radialSummaryCol",
    "radialSummary",
    "firstSection",
    "returnOptions",
    "returnToSection",
    "returnCityOverviewButton",
    "returnToListOfCitiesButton",
    "aggRankingsBox",
    "aggRankingTitle",
    "svg",
    "horizontalCol",
    "aggRankingList",
    "oneBrandCol",
    "fullListCol",
    "viewFullListButton",
    "cityMapStack",
    "mapImageCity",
    "newsTitle",
    "twitterNewsTop",
    "twitterList",
    "newsItemCol",
    "callToActionBanner",
    "twitterNewsTop2",
    "newsTitle2",
    "twitterList4",
    "twitterList2",
    "column",
    "footer"
  ],

  navBar2: ["navBar2"],
  titlesSection: ["titlesSection", "radialSummaryCol", "radialSummary"],
  radialSummaryCol: ["radialSummaryCol", "radialSummary"],
  radialSummary: ["radialSummary"],
  firstSection: [
    "firstSection",
    "returnOptions",
    "returnToSection",
    "returnCityOverviewButton",
    "returnToListOfCitiesButton",
    "aggRankingsBox",
    "aggRankingTitle",
    "svg",
    "horizontalCol",
    "aggRankingList",
    "oneBrandCol",
    "fullListCol",
    "viewFullListButton",
    "cityMapStack",
    "mapImageCity",
    "newsTitle",
    "twitterNewsTop",
    "twitterList",
    "newsItemCol"
  ],

  returnOptions: [
    "returnOptions",
    "returnToSection",
    "returnCityOverviewButton",
    "returnToListOfCitiesButton"
  ],

  returnToSection: ["returnToSection"],
  returnCityOverviewButton: ["returnCityOverviewButton"],
  returnToListOfCitiesButton: ["returnToListOfCitiesButton"],
  aggRankingsBox: [
    "aggRankingsBox",
    "aggRankingTitle",
    "svg",
    "horizontalCol",
    "aggRankingList",
    "oneBrandCol",
    "fullListCol",
    "viewFullListButton"
  ],

  aggRankingTitle: ["aggRankingTitle", "svg"],
  svg: ["svg"],
  horizontalCol: ["horizontalCol", "aggRankingList", "oneBrandCol"],
  aggRankingList: ["aggRankingList", "oneBrandCol"],
  oneBrandCol: ["oneBrandCol"],
  fullListCol: ["fullListCol", "viewFullListButton"],
  viewFullListButton: ["viewFullListButton"],
  cityMapStack: ["cityMapStack", "mapImageCity"],
  mapImageCity: ["mapImageCity"],
  newsTitle: ["newsTitle"],
  twitterNewsTop: ["twitterNewsTop", "twitterList", "newsItemCol"],
  twitterList: ["twitterList", "newsItemCol"],
  newsItemCol: ["newsItemCol"],
  callToActionBanner: ["callToActionBanner"],
  twitterNewsTop2: [
    "twitterNewsTop2",
    "newsTitle2",
    "twitterList4",
    "twitterList2",
    "column"
  ],

  newsTitle2: ["newsTitle2"],
  twitterList4: ["twitterList4", "twitterList2", "column"],
  twitterList2: ["twitterList2", "column"],
  column: ["column"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCityPage__ArgProps,
          internalVariantPropNames: PlasmicCityPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCityPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCityPage";
  } else {
    func.displayName = `PlasmicCityPage.${nodeName}`;
  }
  return func;
}

export const PlasmicCityPage = Object.assign(
  // Top-level PlasmicCityPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar2: makeNodeComponent("navBar2"),
    titlesSection: makeNodeComponent("titlesSection"),
    radialSummaryCol: makeNodeComponent("radialSummaryCol"),
    radialSummary: makeNodeComponent("radialSummary"),
    firstSection: makeNodeComponent("firstSection"),
    returnOptions: makeNodeComponent("returnOptions"),
    returnToSection: makeNodeComponent("returnToSection"),
    returnCityOverviewButton: makeNodeComponent("returnCityOverviewButton"),
    returnToListOfCitiesButton: makeNodeComponent("returnToListOfCitiesButton"),
    aggRankingsBox: makeNodeComponent("aggRankingsBox"),
    aggRankingTitle: makeNodeComponent("aggRankingTitle"),
    svg: makeNodeComponent("svg"),
    horizontalCol: makeNodeComponent("horizontalCol"),
    aggRankingList: makeNodeComponent("aggRankingList"),
    oneBrandCol: makeNodeComponent("oneBrandCol"),
    fullListCol: makeNodeComponent("fullListCol"),
    viewFullListButton: makeNodeComponent("viewFullListButton"),
    cityMapStack: makeNodeComponent("cityMapStack"),
    mapImageCity: makeNodeComponent("mapImageCity"),
    newsTitle: makeNodeComponent("newsTitle"),
    twitterNewsTop: makeNodeComponent("twitterNewsTop"),
    twitterList: makeNodeComponent("twitterList"),
    newsItemCol: makeNodeComponent("newsItemCol"),
    callToActionBanner: makeNodeComponent("callToActionBanner"),
    twitterNewsTop2: makeNodeComponent("twitterNewsTop2"),
    newsTitle2: makeNodeComponent("newsTitle2"),
    twitterList4: makeNodeComponent("twitterList4"),
    twitterList2: makeNodeComponent("twitterList2"),
    column: makeNodeComponent("column"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicCityPage
    internalVariantProps: PlasmicCityPage__VariantProps,
    internalArgProps: PlasmicCityPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Basil Labs Cities",
      description:
        "A global index of retailers benchmarked by consumer experience",
      ogImageSrc:
        "https://site-assets.plasmic.app/a9c047168a332e71149b68af02fe575a.png",
      canonical: ""
    }
  }
);

export default PlasmicCityPage;
/* prettier-ignore-end */
